module.exports = __webpack_public_path__ + "img/belieze.8ae240a.png";